import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
var _hoisted_1 = { class: "row" };
var _hoisted_2 = { class: "col-12 col-md-8 col-lg-9" };
var _hoisted_3 = {
    key: 0,
    class: "card"
};
var _hoisted_4 = { class: "card-body" };
var _hoisted_5 = { class: "subs disabled" };
var _hoisted_6 = { class: "text-center" };
var _hoisted_7 = { class: "text-center" };
var _hoisted_8 = { class: "row pt-4" };
var _hoisted_9 = { class: "col-12 col-sm-6 col-md-4" };
var _hoisted_10 = { class: "col-12 col-sm-6 col-md-4" };
var _hoisted_11 = { class: "col-12 col-sm-12 col-md-4" };
var _hoisted_12 = { class: "d-flex flex-column align-items-center gap-1" };
var _hoisted_13 = ["onClick"];
var _hoisted_14 = {
    key: 1,
    class: "card"
};
var _hoisted_15 = { class: "card-body" };
var _hoisted_16 = { class: "d-none d-md-block col-md-4 col-lg-3" };
var _hoisted_17 = {
    href: "https://wa.me/59169893486",
    class: "btn btn-whatsapp d-inline-flex align-items-center",
    target: "_blank",
    rel: "noopener noreferrer"
};
var _hoisted_18 = { class: "modal-dialog" };
var _hoisted_19 = { class: "modal-content" };
var _hoisted_20 = { class: "modal-body" };
import { onMounted, ref } from 'vue';
import { dateFormat } from '@/utils/dateformat';
import { useAuthStore } from '@/stores/authStore';
import { subscription } from '@/api/public/client';
import { Modal } from 'bootstrap';
import SubData from '@/components/Customer/SubData.vue';
import VoucherUpload from '@/components/Customer/VoucherUpload.vue';
var voucherUploadID = 'voucher-upload-modal';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DasboardClient',
    setup: function (__props) {
        var _this = this;
        var _a;
        var auth = useAuthStore();
        var role = ref((_a = auth.user) === null || _a === void 0 ? void 0 : _a.role);
        var subsDis = ref([]);
        var subsEna = ref([]);
        var voucher = ref();
        var voucherUploadModal = ref(null);
        var onSubscription = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        subsDis.value = [];
                        subsEna.value = [];
                        return [4 /*yield*/, subscription()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            subsDis.value = response.data.subsToConfirm;
                            subsEna.value = response.data.subsActives;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var completeUpload = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                (_a = voucherUploadModal.value) === null || _a === void 0 ? void 0 : _a.hide();
                onSubscription();
                return [2 /*return*/];
            });
        }); };
        var uploadVoucher = function (id) {
            var _a;
            voucher.value.setSubID(id);
            (_a = voucherUploadModal.value) === null || _a === void 0 ? void 0 : _a.show();
        };
        onMounted(function () {
            var modalElement = document.getElementById(voucherUploadID);
            voucherUploadModal.value = new Modal(modalElement);
            onSubscription();
        });
        return function (_ctx, _cache) {
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (subsDis.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-center" }, "Suscripciones pendientes", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subsDis.value, function (sub) {
                                    var _a, _b, _c;
                                    return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("h4", _hoisted_6, _toDisplayString((_b = (_a = sub.group) === null || _a === void 0 ? void 0 : _a.platform) === null || _b === void 0 ? void 0 : _b.name), 1),
                                        _createElementVNode("h5", _hoisted_7, _toDisplayString((_c = sub.group) === null || _c === void 0 ? void 0 : _c.groupName), 1),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("dl", null, [
                                                    _cache[0] || (_cache[0] = _createElementVNode("dt", null, "Precio", -1)),
                                                    _createTextVNode("$us " + _toDisplayString(sub.cost), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("dl", null, [
                                                    _cache[1] || (_cache[1] = _createElementVNode("dt", null, "Fecha de solicitud", -1)),
                                                    _createTextVNode(_toDisplayString(_unref(dateFormat)(sub.createdAt, 'DD MMMM')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "badge rounded-pill bg-warning text-dark" }, [
                                                        _createElementVNode("h4", { class: "mx-4 my-2" }, "Pendiente")
                                                    ], -1)),
                                                    _createElementVNode("button", {
                                                        class: "btn btn-info w-50",
                                                        onClick: function ($event) { return (uploadVoucher(sub.id)); }
                                                    }, "Subir Doc. Pago", 8, _hoisted_13)
                                                ])
                                            ])
                                        ]),
                                        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1))
                                    ]));
                                }), 256))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (subsEna.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-center" }, "Suscripciones Válidas", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subsEna.value, function (sub) {
                                    return (_openBlock(), _createElementBlock("div", null, [
                                        _createVNode(SubData, { suscription: sub }, null, 8, ["suscription"])
                                    ]));
                                }), 256))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", _hoisted_17, [
                        _createVNode(_component_font_awesome_icon, {
                            icon: ['fab', 'whatsapp'],
                            class: "me-2"
                        }),
                        _cache[6] || (_cache[6] = _createTextVNode(" Soporte por WhatsApp "))
                    ])
                ]),
                _createElementVNode("div", {
                    class: "modal fade",
                    tabindex: "-1",
                    "aria-labelledby": "modalLabel",
                    "aria-hidden": "true",
                    id: voucherUploadID
                }, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _createVNode(VoucherUpload, {
                                    "complete-upload": completeUpload,
                                    ref_key: "voucher",
                                    ref: voucher
                                }, null, 512)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
